export function deleteEmptyParams(obj: any) {
    return Object.fromEntries(
        Object.entries(obj).filter(([k, v]) => v !== null && v !== undefined && v !== '' && v !== 0)
    );
}